<template>
  <action-dispatcher
    action="courses/getLesson"
    :parameters="{
      course_id: $route.params.id,
      lesson_id: $route.params.lesson
    }"
  >
    <div class="view-course-lesson py-5">
      <div class="container">
        <button @click="back" class="btn-back">
          <i class="icon-arrow-left"></i>
          VOLTAR
        </button>

        <div class="d-flex text-center align-items-end my-4">
          <router-link
            class="btn btn-outline-dark d-none d-lg-block"
            v-if="previousLesson"
            :to="{
              params: {
                lesson: previousLesson.id
              }
            }"
          >
            <i class="icon-chevron-left"></i>
            Aula {{ previousLesson.number }}
          </router-link>
          <h1 class="mb-0 flex-fill mx-3">
            {{ lesson.name }}
          </h1>
          <router-link
            class="btn btn-outline-dark d-none d-lg-block"
            v-if="nextLesson"
            :to="{
              params: {
                lesson: nextLesson.id
              }
            }"
          >
            Aula {{ nextLesson.number }}
            <i class="icon-chevron-right"></i>
          </router-link>
        </div>

        <video-player
          v-if="lesson.featured"
          :lesson="lesson.featured"
          :progress="lesson.progress"
          @save-progress="saveProgress"
          class="mb-5"
        />

        <div
          v-if="lesson.description"
          class="lesson-description mb-5"
          v-html="addTimeLinks(lesson.description)"
        />

        <div v-else class="lesson-description">
          <template v-if="lesson.desc_synopsis">
            <h4>Sinopse</h4>
            <div
              v-html="lesson.desc_synopsis"
              class="synopsis font-serif"
            ></div>
            <hr />
          </template>
          <template v-if="lesson.desc_summary">
            <h4>Sumário Temático</h4>
            <div v-html="lesson.desc_summary"></div>
            <hr />
          </template>
          <template v-if="lesson.desc_index">
            <h4>Índice Temático da Aula</h4>
            <div v-html="addTimeLinks(lesson.desc_index)"></div>
            <hr />
          </template>
          <template v-if="lesson.desc_references">
            <h4>Referências</h4>
            <div v-html="lesson.desc_references"></div>
            <hr />
          </template>
        </div>

        <h4>Materiais complementares</h4>

        <archives :archives="lesson.resources" />

        <hr />

        <div class="row mt-5">
          <div class="col-lg-6">
            <h4>Aulas anteriores</h4>

            <div class="row">
              <div
                v-for="(lesson, index) in previousLessons"
                :key="index"
                class="col-md-6 py-2"
              >
                <lesson-img :lesson="lesson" route="course-lesson" />
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <h4>Próximas aulas</h4>

            <div class="row">
              <div
                v-for="(lesson, index) in nextLessons"
                :key="index"
                class="col-md-6 py-2"
              >
                <lesson-img :lesson="lesson" route="course-lesson" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import VideoPlayer from "@/components/lesson/VideoPlayer";
// import CommentForm from "@/components/lesson/CommentForm";
import Archives from "@/components/Archives";
import { mapState } from "vuex";
import { get, first, last } from "lodash";

export default {
  components: {
    // CommentForm,
    Archives,
    VideoPlayer
  },
  data() {
    return {
      lessons: Array(3).fill("")
    };
  },
  computed: {
    ...mapState("courses", ["lesson"]),
    ...mapState("comments", ["comments"]),
    previousLessons() {
      return [...get(this.lesson, "previous", [])].sort(
        (a, b) => a.number - b.number
      );
    },
    nextLessons() {
      return [...get(this.lesson, "near", [])].sort(
        (a, b) => a.number - b.number
      );
    },
    previousLesson() {
      return last(this.previousLessons);
    },
    nextLesson() {
      return first(this.nextLessons);
    }
  },
  methods: {
    addTimeLinks(text) {
      return text.replace(
        /(\d{2}:\d{2}:\d{2})/g,
        "<a href=\"javascript:window.setTime('$1');\">$1</a>"
      );
    },
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "course-lessons" });
      }
    },
    reloadComments() {
      this.$refs.commentsDispatcher.dispatch();
    },
    saveProgress({ finished, duration }, refresh = false) {
      if (refresh) {
        this.loadingFinish = true;
      }
      this.$store
        .dispatch("students/setProgress", {
          lesson: this.lesson.id,
          stopped_at: parseInt(duration),
          finished_at: finished
        })
        .then(() => {
          if (refresh) {
            this.$store
              .dispatch("courses/getDetails", this.$route.params.id)
              .finally(() => {
                this.loadingFinish = false;
              });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-course-lesson {
  h1 {
    margin-bottom: 0;
  }

  .subtitle {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
    margin-bottom: 52px;
  }

  hr {
    border-color: #a9a395;
    margin: 64px 0;
  }

  .lesson-description {
    color: #494640;

    ::v-deep hr {
      border-color: #a9a395;
      margin: 64px 0;
    }

    ::v-deep h1,
    ::v-deep h2,
    ::v-deep h3,
    ::v-deep h4 {
      margin-bottom: 24px;
    }

    .synopsis {
      font-style: italic;
      border-left: 4px solid #f16336;
      padding-left: 32px;
    }
  }

  .btn-back {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    transition: color 0.2s;
    background: transparent;
    border: none;
    padding: 0;

    &:hover {
      color: rgba(0, 25, 50, 0.6);
    }
  }
}
</style>
